import react from "react";
import Request from "../../../../api/Requests";
import axios from 'axios';

const getInfoFormEvent = (params) => {

    return Request('events/info-form', 'GET', params, true);
}

const postEvent = (params) => {

    return Request('events/update-form', 'POST', params, true);
}

const getListPromoterEvent = (params) => {

    return Request('events/get-list-promoters-event', 'POST', params, true);
}


const saveTicketsForm = (params) => {

    return Request('events/save-tickets-form-event', 'POST', params, true);
}

const getTicketsForm = (params) => {

    return Request('events/get-tickets-form-event', 'POST', params, true);
}

const changePromoterAccess = (params) => {

    return Request('events/change-promoter-access', 'POST', params, true);
}


const saveEvent = async (params) => {
    //return Request('venues/upload-venues-images', 'POST', params, true);
    var response = null;
    const formData = new FormData();

    //const filesAsStrings = [...images].map((file) => file);

    // filesAsStrings.forEach((file) => {
    //     formData.append('files[]', file);
    // });
    Object.keys(params).forEach((key) => {
        if (params[key] && params[key] !== "") {
            //console.log(params[key])
            formData.append(key, params[key]);
        }
    });

    formData.append("location", JSON.stringify(params.location));
    formData.append("guestlist", JSON.stringify(params.guestlist))
    formData.append("tables", JSON.stringify(params.tables))
    formData.append("tickets", JSON.stringify(params.tickets))

    formData.append("music_genre_list", JSON.stringify(params.music_genre))

    
    let token = localStorage.getItem("token-api");
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;

    // Make the request
    
    await axios.post(process.env.REACT_APP_API_URL+'/index.php?r=events/update-form', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then((dataResponse) => {
        response = dataResponse
    }).catch((error) => {
        if (error.response.status === 401) {
            localStorage.removeItem('token-api');
        }
    });
    if (response.status === 200) {
        return response.data;
    } else {
        return null;
    }
}

const getFloorImage = (params) => {
    return Request('events/table-get-floor-image', 'GET', params, true);
}

const getTables = (params) => {
    return Request('events/table-list', 'GET', params, true);
}
const getTable = (params) => {
    return Request('events/table-form-info', 'GET', params, true);
}

const importTables = (params) => {
    return Request('events/table-import', 'GET', params, true);
}

const postTable = (params) => {
    return Request('events/table-form-save', 'POST', params, true);
}

const deleteTable = (params) => {
    return Request('events/table-delete', 'POST', params, true);
}
const deleteTicket = (params) => {
    return Request('events/ticket-delete', 'POST', params, true);
}

const saveFloorImage = async (params) => {
    var response = null;
    const formData = new FormData();
    formData.append("image", params.image);
    
    formData.append("id_events", params.id_events);
    let token = localStorage.getItem("token-api");
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    await axios.post(process.env.REACT_APP_API_URL+'/index.php?r=events/table-form-floor-image', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then((dataResponse) => {
        response = dataResponse
    }).catch((error) => {
        if (error.response.status === 401) {
            localStorage.removeItem('token-api');
        }
    });
    if (response.status === 200) {
        return response.data;
    } else {
        return null;
    }
}

export default {
    getInfoFormEvent,
    postEvent,
    saveEvent,
    getListPromoterEvent,
    saveTicketsForm,
    getTicketsForm,
    changePromoterAccess,
    getFloorImage,
    saveFloorImage,
    getTables,
    getTable,
    postTable,
    importTables,
    deleteTable,
    deleteTicket
}